import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { CATEGORIES, getLocalizedName } from '../../data/categories';
import { useLanguage } from '../../context/LanguageContext';
import { CategoryIcon, CATEGORY_TINTS, subcategoryPath } from './CategoryBrowser';
import { cn } from '../../lib/utils';

const MAX_SUBS = 6;

export const CategoryMegaMenu = ({ counts = {}, onNavigate }) => {
  const { t, language } = useLanguage();
  return (
    <div className="absolute top-full left-0 mt-2 w-[min(1080px,calc(100vw-2rem))] max-h-[calc(100vh-130px)] overflow-y-auto bg-white rounded-2xl shadow-2xl border border-gray-100 p-5 z-50 animate-in fade-in slide-in-from-top-1 duration-150" data-testid="category-mega-menu">
      <div className="grid grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-5">
        {CATEGORIES.map((cat) => {
          const subs = cat.subcategories.slice(0, MAX_SUBS);
          const more = cat.subcategories.length - subs.length;
          return (
            <div key={cat.id} className="min-w-0" data-testid={`mega-cat-${cat.id}`}>
              <Link to={`/category/${cat.id}`} onClick={onNavigate} className="group flex items-center gap-2.5 mb-2">
                <span className={cn('h-8 w-8 rounded-lg flex items-center justify-center shrink-0', CATEGORY_TINTS[cat.id])}><CategoryIcon id={cat.id} className="h-4 w-4" /></span>
                <span className="min-w-0">
                  <span className="block text-sm font-semibold text-gray-900 group-hover:text-emerald-700 truncate">{getLocalizedName(cat, language)}</span>
                  {typeof counts[cat.id] === 'number' && <span className="block text-[11px] text-gray-400">{counts[cat.id].toLocaleString()} {t(counts[cat.id] === 1 ? 'browser.ad' : 'browser.ads')}</span>}
                </span>
              </Link>
              <ul className="space-y-1 pl-[42px]">
                {subs.map((sub) => (
                  <li key={sub.id}>
                    <Link to={subcategoryPath(cat.id, sub.id)} onClick={onNavigate} className="text-[13px] text-gray-600 hover:text-emerald-700 hover:underline underline-offset-2" data-testid={`mega-sub-${sub.id}`}>
                      {getLocalizedName(sub, language)}
                    </Link>
                  </li>
                ))}
                {more > 0 && (
                  <li>
                    <Link to={`/category/${cat.id}`} onClick={onNavigate} className="inline-flex items-center gap-0.5 text-[13px] font-medium text-emerald-700 hover:underline underline-offset-2">
                      +{more} <ChevronRight className="h-3 w-3" />
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryMegaMenu;
